<script setup lang="ts">
import { ParagraphHotspotGraphic } from '~/api/graphql/generated'
const props = defineProps<{
  entity: ParagraphHotspotGraphic
}>()
</script>

<template>
  <Section :id="entity.fieldId || 'hotspotGraphic'" class="hotspot-section">
    <div class="t-10 t-o-1 tl-7 tl-o-0 ds-o-1 hotspot-title">
      <h2 v-if="entity?.fieldTitle">{{ entity?.fieldTitle }}</h2>
      <div
        v-if="entity.fieldDescription?.processed"
        class="field-description"
        v-html="entity.fieldDescription?.processed"
      />
    </div>
    <HotspotItem :entity="entity" />
  </Section>
</template>

<style scoped lang="scss">
.hotspot-section {
  --container-padding: 0;

  @include breakpoint(ds) {
    --container-padding: var(--layout-padding);
  }
  .hotspot-title {
    padding: var(--layout-padding);
    @include breakpoint(ds) {
      padding: 0;
    }
  }
}
.field-description {
  max-width: 825px;
}
</style>
